<template lang="html">
  <div class="ref-container">
    <div v-for="(ref, i) in references" :key="i">
      <span class="snippet" v-for="(snippet, j) in ref" :key="`${i}_${j}`">
        <template v-if="'link' in snippet">
          <a :href="snippet.link">{{ snippet.text }}</a>
        </template>
        <template v-else>
          {{ snippet.text }}
        </template>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    references: Array
  }
};
</script>

<style lang="css" scoped>
.ref-container {
  padding: 0px 25px;
  margin-bottom: 30px;
}
.snippet {
  margin-right: 3px;
}
</style>
